// extracted by mini-css-extract-plugin
export var actionButton = "_a3-0";
export var attachmentLine = "_a3-1";
export var fileInput = "_a3-2";
export var fileUploadWrapper = "_a3-4";
export var footer = "_a3-3";
export var modalContent = "_a3-5";
export var paperclip = "_a3-6";
export var quillEditor = "_a3-7";